import { MarketRate, OrderSide } from "@cede/types";

export const getCurrentRate = (marketRate: MarketRate | undefined, orderSide: OrderSide) => {
  if (!marketRate) return "0";
  return orderSide === "buy" ? marketRate.ask : marketRate.bid;
};
